// 设置cookie
export function setCookie(name, pwd, exdays) {
  var exdate = new Date() // 获取时间
  exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
  // 字符串拼接cookie
  window.document.cookie = 'UserName' + '=' + name + ';path=/;expires=' + exdate.toGMTString()
  window.document.cookie = 'PassWord' + '=' + pwd + ';path=/;expires=' + exdate.toGMTString()
}
// 读取cookie 将用户名和密码回显到input框中
export function getCookie() {
  let form = {}
  if (document.cookie.length > 0) {
    var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
    for (var i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=') // 再次切割
      // 判断查找相对应的值
      if (arr2[0] === 'UserName') {
        form.UserName = arr2[1] // 保存到保存数据的地方
      } else if (arr2[0] === 'PassWord') {
        form.PassWord = arr2[1]
      }
    }
  }
  return form
}

// 下载表格时参数处理
export function generateTableParms(obj) {
  let params = `?`
  for (const key in obj) {
    if (obj[key] instanceof Array) {
      for (const value of obj[key]) {
        params += `${key}=${value}&`
      }
    } else {
      params += `${key}=${obj[key]}&`
    }
  }
  params = params.substring(0, params.length - 1)
  return params
}

//获取token
export function getToken() {
  return { ssotoken: JSON.parse(sessionStorage.getItem('userInfo')).ssotoken }
}

// 下载文件名处理
export function excelName(name, d1, d2) {
  if (d1 == d2) {
    return `${name}(${d1})`
  }

  return `${name}(${d1}_${d2})`
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function (...rest) {
    args = rest
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, rest)
      context = rest = null
    }

    return result
  }
}
